<template>
  <div>
    <form-container
      :header="translate('draft.newJob')"
      v-on:save="saveDraft()"
      v-if="data"
      :disabled="loading || data.RelatedJob != null"
      :loading="loading"
      :formStyle="{ 'background-color': (tab == 'ozet' ? '#FFF' : null) }"
    >
      <template v-slot:commands>
        <div class="float-right">
          <router-link
            :to="{ name: 'DraftList', params: {} }"
            style="margin-right: 12px"
          >
          <button type="button" class="btn btn-outline-info">{{translate('draft.draftList')}}</button>
          </router-link>
          <button @click="resetComponent" class="btn btn-outline-secondary">
            {{translate('draft.cleanPage')}}
          </button>
        </div>
      </template>
      <template v-slot:tabs>
          <tab :tabs="tabs" v-model="tab" ref="tabs"></tab>
      </template>

      <div class="alert alert-warning" v-if="data.RelatedJob">
        {{translate('draft.relatedJob:' + relatedJobDate(data.RelatedJob.StartDate))}}
      </div>

      <tab-content tabName="genel" :currentTab="tab" class="justify-content-md-center">
      <!-- <div class="row tab-panel justify-content-md-center" v-show="tab == 'genel'"> -->
          <div class="col col-limit-800">
              <div class="form-group">
                  <label>{{translate('draft.jobName')}}</label>
                  <input v-model.trim="data.Title" ref="draftTitle" name="Title" type="text" class="form-control" @input="checkInput('Title',$event)"/>
              </div>

              <div class="form-group" v-if="data.ReferenceJob">
                  <label>{{translate('draft.referenceJob')}}</label>
                  <div class="form-control">
                      <router-link target="_blank" :to="{ name: 'JobMyDetail', params: { id : data.ReferenceJob.Id } }">
                          {{data.ReferenceJob.TrackingNo | trackingNo}}
                      </router-link> —
                      {{data.ReferenceJob.Title}}
                  </div>
              </div>
              <div class="row">
                  <div class="col">
                      <div class="form-group">
                          <label>{{translate('draft.docNo')}}</label>
                          <input type="text" v-model.trim="data.DocumentNumber" maxlength="100" class="form-control" @input="checkInput('DocumentNumber',$event)" />
                      </div>
                  </div>
                  <div class="col">
                      <div class="form-group">
                          <label>{{translate('draft.department')}}</label>
                          <select-input
                              :value="data.DepartmentId"
                              :key="data.DepartmentId"
                              :autocomplete="true"
                              :placeholder="translate('search')"
                              name="Department"
                              :items="availableDepartments"
                              :filter-function="(item, search) => new RegExp(search, 'i').test(item.Name)"
                              :max-height="'300'"
                              @change="departmentSelectChanged"
                              style="width:100%;">
                                  <span v-if="data.DepartmentId">
                                      {{selectedDepartment.Name}}
                                  </span>
                                  <span v-else>{{translate('draft.departmentIndependent')}}</span>
                                  <template v-slot:item="{item}">
                                      <div style="padding:2px 0;">
                                          {{item.Name}}
                                      </div>
                                  </template>
                          </select-input>
                          <small class="form-text text-muted">{{translate('draft.departmentText')}}</small>
                          <!-- <label>Doküman tipi</label>
                          <select class="form-control" v-model="data.DocumentType" @change="changeDocumentType($event)">
                              <option v-for="(obj, i) in $izonay.documentTypes" :key="i" :value="i">{{obj.text}}</option>
                          </select> -->
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col">
                      <div class="form-group">
                        <label>{{translate('draft.categories')}}</label>
                        <select-multiple v-model="data.CategoryIds" @change="categorySelectChanged"  :autocomplete="true" :list="availableCategories" style="height:148px;"></select-multiple>
                      </div>
                  </div>
                  <div class="col">
                      <div class="form-group">
                          <label>{{translate('draft.targetDate')}}</label>
                          <date-input v-model="data.TargetDate" ref="targetDate" name="TargetDate" :min="new Date().toISOString().substring(0, 10)" class="form-control"></date-input>
                          <small class="form-text text-muted">{{translate('draft.targetDateText')}}</small>
                      </div>
                      <div v-if="isBankOrder" class="form-group">
                          <label>{{translate('draft.orderAmount')}}</label>
                          <div class="input-group">
                              <input type="number" v-model.number="data.Amount" class="form-control text-right" :placeholder="translate('draft.amount')">
                              <select v-model="data.Currency" class="custom-select" style="max-width:70px;">
                                      <option label="₺" value="TRY" >₺</option>
                                      <option label="$" value="USD" >$</option>
                                      <option label="€" value="EUR" >€</option>
                                      <option label="£" value="GBP">£</option>
                                      <option label="¥" value="JPY">¥</option>
                              </select>
                          </div>
                      </div>

                      <div v-if="isContract" class="form-group">
                          <label>{{translate('draft.contractAmount')}}</label>
                          <div class="input-group">
                              <input type="number" v-model.number="data.ContractAmount" class="form-control text-right" :placeholder="translate('draft.amount')">
                              <select v-model="data.ContractCurrency" class="custom-select" style="max-width:70px;">
                                      <option label="₺" value="TRY" >₺</option>
                                      <option label="$" value="USD" >$</option>
                                      <option label="€" value="EUR" >€</option>
                                      <option label="£" value="GBP">£</option>
                                      <option label="¥" value="JPY">¥</option>
                              </select>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col">
                      <div class="form-group">
                          <label>{{translate('draft.docPrivacy')}}</label>
                          <select name="" id="" v-model="data.Privacy" class="form-control">
                            <option value="Normal">{{translate('draft.normal')}}</option>
                            <option value="Secret" v-if="data.DepartmentId">{{translate('draft.secret')}}</option>
                            <option value="TopSecret">{{translate('draft.topSecret')}}</option>
                          </select>
                          <small class="form-text text-muted">
                          {{ data.Privacy | privacyDescription }}
                        </small>
                      </div>
                  </div>
                  <div class="col">
                      <div class="form-group" v-if="hasModule('IncomingDocManagement')">
                          <label>{{translate('draft.incomingDocId')}}</label>
                          <input type="text" v-model.trim="data.IncomingDocId" maxlength="100" class="form-control"  @input="checkInput('IncomingDocId',$event)" />
                      </div>
                </div>
              </div>
              <draftAlerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />
          </div>  
      <!-- </div> -->
      </tab-content>

      <tab-content tabName="dolasim" :currentTab="tab">
      <!-- <div class="row tab-panel" v-show="tab == 'dolasim'"> -->
        <div class="col">
          <div class="row justify-content-md-center">
            <div class="col-6">
              <div class="row">
                <div class="col col-limit-800">
                  <label>{{translate('draft.jobFlows')}}</label>
                  <div class="input-group">
                    <select-input
                      ref="circulationProfileSchemaId"
                      name="CirculationProfileSchemaId"
                      :value="data.CirculationProfileSchemaId"
                      :autocomplete="true"
                      :placeholder="translate('search')"
                      :items="availableCirculationProfileSchemas"
                      :filter-function="
                        (item, search) => new RegExp(search, 'i').test(item.Name)
                      "
                      @change="circulationProfileSchemaChanged"
                    >
                    
                      <span v-if="data.CirculationProfileSchemaId == ''"><i>{{translate('draft.chooseDefinedJobFlow')}}</i></span>
                      <span v-else-if="circulationProfileSchema">
                        {{ circulationProfileSchema.Name }}
                      </span>
                      <template v-slot:item="{ item }">
                        <div style="padding: 2px 0">
                          {{ item.Name }}
                        </div>
                      </template>
                    </select-input>
                    <div class="input-group-append" v-if="hasAuth('DraftCirculationCustomization')">
                      <button
                        :disabled="!data.CirculationProfileSchemaId"
                        @click="customizeCirculationProfile"
                        type="button"
                        class="btn btn-block btn-primary btn-disabled-custom"
                      >
                      {{translate('draft.customize')}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr style="padding-bottom: 15px" />
          <div class="row" v-show="circulationProfileSchema">
            <div class="col-6">
              <div class="form-group">
                <label>1 - {{translate('draft.signApproveSteps')}}</label>
                <step-editor
                  ref="stepEditor"
                  name="Steps"
                  class="form-control"
                  style="height:400px; overflow-y:auto; padding: 16px 16px 16px 0;"
                  :key="data.CirculationProfileSchemaId"
                  v-model="data.Steps"
                  :user-list="availableUserList"
                  :editable="isSpecialProfile"
                ></step-editor>
              </div>
              <button v-show="isSpecialProfile" type="button" class="btn btn-sm btn-outline-secondary float-right" @click="$refs.stepEditor.addStep()"><icon-plus/> {{translate('circulationProfileSchema.addStep')}}</button>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>2 - {{translate('circulationProfileSchema.targetSystems')}}</label>
                <select-multiple
                  style="height:400px;"
                  ref="targetSystemSelect"
                  name="TargetSystems"
                  :key="data.CirculationProfileSchemaId"
                  v-model="data.TargetSystemIds"
                  :additionalItems="data.AdditionalTargetSystems"
                  @removeAdditionalItem="removeCustomTargetSystem"
                  :autocomplete="true"
                  :readonly="isSpecialProfile == false"
                  :list="departmentBasedAvailableTargetSystems"
                  :emptyLabel="translate('draft.targetSystemEmptyLabel')"
                  :chooseLabel="translate('draft.targetSystemChooseLabel')"
                >
                  <template #default="{ item }">
                    <div style="padding:2px;">
                      <div style="display: flex;">
                        <div :title="item.Name" class="truncate" style="flex-grow:100;">
                          {{item.Name}}
                        </div>
                        <template v-if="hasAuth('DraftCirculationCustomization') && isSpecialProfile == true">
                          <a v-if="!item.IsSingleUse && (item.Kind == 'Email' || item.Kind == 'Rem')" style="flex-grow:1; flex-basis:1px; font-size:0.8rem;  width:100px;" href="#void" @click.prevent="customizeTargetSystem(item)">{{translate('draft.customize')}}</a>
                          <a v-if="item.IsSingleUse" style="flex-grow:1; flex-basis:1px; font-size:0.8rem; width:100px;" href="#void" @click.prevent="customTargetSystem = item">{{translate('edit')}}</a>
                        </template>
                      </div>
                      <div class="text-muted" style="font-size:0.75rem;">
                          <span style="font-weight:bold; text-transform: uppercase; padding-right:8px;">{{item.Kind | targetSystemKind }}</span>
                          <span v-if="item.ExtraFields" :title="item.ExtraFields[0].Value" >{{item.ExtraFields[0].Value}}</span>
                          <span v-if="item.IsSingleUse && (item.Kind == 'Email' || item.Kind == 'Rem')">
                            <span v-for="(mail, i) in item.To" :key="mail"><template v-if="i > 0">, </template>{{mail}}</span>
                          </span>
                      </div>
                    </div>
                  </template>
                </select-multiple>
              </div>

              <button type="button" v-if="isSpecialProfile && hasAuth('DraftCirculationCustomization')" class="btn btn-outline-secondary float-right btn-sm" @click.prevent="addNewCustomTargetSystem">
                  <icon-plus/>{{translate('draft.addJobSpecialTargetSystem')}}
              </button>
            </div>          
          </div>
          <draftAlerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />
        </div>
      <!-- </div> -->
      </tab-content>

      <tab-content tabName="dosya" :currentTab="tab" class="justify-content-md-center">
      <!-- <div class="row tab-panel justify-content-md-center" v-show="tab == 'dosya'"> -->
        <div class="col col-limit-1200">
          <div class="alert alert-info">{{translate('draft.chooseFilesToCirculate')}}</div>

          <file-upload
          style="display:none"
            ref="upload"
            name="Documents"
            input-id="documentUpload"
            v-model="files"
            :post-action="axios.defaults.baseURL + '/draft/addfile/' + data.Id"
            :multiple="true"
            :drop="false"
            :thread="1"
            @input="$refs.upload.active = true"
            chunk-enabled
            :chunk="{
              headers: {
                token: axios.defaults.headers.common['token'],
              },
              action: axios.defaults.baseURL + '/draftattachment/addfilechunk/' + data.Id,
              //minSize: 1048576,
              minSize: 0,
              maxActive: 3,
              maxRetries: 3,

              // Example in the case your backend also needs the user id to operate
              startBody: {
                //user_id: user.id
              },
            }"
          >
            <!-- <div class="row select-file" id="documents">
              <div class="col">
                İmzaya veya onaya çıkarılacak dosyaları seçmek için buraya
                tıklayınız...
              </div>
            </div> -->
          </file-upload>

          <label>{{translate('draft.filesToSignApprove')}}</label>
          <div class="form-control" style="padding: 0; margin-bottom:1rem; height:auto;">
            <table
              v-if="data.Documents && data.Documents.length"
              class="table table-striped table-hover table-borderless"
              style="margin-bottom:0"
            >
              <thead>
                <tr>
                  <th></th>
                  <th>{{translate('draft.fileName')}}</th>
                  <th class="text-right" style="width: 120px">{{translate('draft.size')}}</th>
                  <th style="width: 150px">{{translate('draft.signatureStandard')}}</th>
                  <th style="width: 120px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in data.Documents" :key="i.Id">
                  <td
                    class="remove align-top"
                    :title="translate('remove')"
                    @click="removeDocument(i)"
                  ></td>
                  <td class="content">
                    <!-- <a
                      v-if="canDownload"
                      :title="translate('download')"
                      href="#void"
                      @click.prevent="downloadDocument(i)"
                      >{{ i.File.FileName }}</a
                    >
                    <span v-else>{{i.File.FileName}}</span> -->
                    <file-download-link  :isOnlineView="onlineViewEnabled" :document="i" @download="downloadDocument" @preview="showFilePreview" ></file-download-link>
                  </td>
                  <td class="text-right">{{ i.File.Size | prettyBytes }}</td>
                  <td>
                    <select
                      v-model="i.SignatureFormat"
                      class="signature-format"
                      v-if="canSelectSignatureStandard() == true && !isEYP(i.SignatureFormat)"
                    >
                      <option :hidden="!hasModule('PAdES') || getFileExtension(i.File.FileName) != 'pdf'" :value="'PAdES'">
                        {{ 'PAdES' | signatureFormat}}
                      </option>
                      
                      <option :hidden="i.SignatureFormat !='Guarantee'  || getFileExtension(i.File.FileName) != 'xml'" :value="'Guarantee'">
                        {{ 'Guarantee' | signatureFormat}}
                      </option>
                      
                      <option :value="'CAdES'">{{ 'CAdES' | signatureFormat}}
                      </option>
                      <option :value="'CAdES_Serial'">{{ 'CAdES (Seri)' | signatureFormat}}
                      </option>
                    </select>
                    <div v-else>
                      {{ i.SignatureFormat | signatureFormat }}
                    </div>                             
                  </td>
                  <td style="padding:0; vertical-align:middle;">
                    <template v-if="i.SignatureFormat == 'PAdES'">
                      <button
                        type="button"
                        class="btn btn-link btn-sm"
                        @click="showSignatureEditor(i, true)"
                        style="white-space:pre"
                      >
                      {{translate('draft.placeSignature')}}
                      </button>
                      <signature-location
                        :draft.sync="data"
                        :document.sync="i"
                        @close="showSignatureEditor(i, false)"
                        :page="1"
                        v-if="i.showLocator"
                      ></signature-location>
                    </template>
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="data.Documents && data.Documents.length > 1">
                <tr>
                  <td colspan="2" class="text-right">{{translate('draft.sum')}}:</td>
                  <td class="text-right" style="font-weight:bold">{{totalDocumentSize | prettyBytes}}</td>
                  <td colspan="2"></td>
                </tr>
              </tfoot>
            </table>
            <label v-else class="text-muted text-center" style="padding:40px; display:block; cursor:pointer;" for="documentUpload">
              {{translate('warnings.noFileUploaded')}}
            </label>
          </div>
          <div class="row">
            <div class="col" style="display: flex; flex-direction: row; align-items: center;">
              <div v-if="!canCreateEYP" class="ml-2" :title="translate('draft.eypBlockedText')" v-title> <img src="../assets/information.png" class="informationIcon" alt=""> </div>
              <button style="margin-left:8px;" :disabled="!canCreateEYP" type="button" @click="addEypButtonClick()" class="btn btn-outline-secondary btn-sm" :title="translate('draft.eypHelperText')"><icon-plus/>
                {{translate('draftEyp.createEYP')}}</button>
                
              <button type="button" class="btn btn-outline-secondary btn-sm ml-2" @click="mergePdf = !mergePdf">{{translate('draft.mergePdf')}}</button>
              
            </div>
            <div class="col text-right">
              <label for="documentUpload" class="btn btn-outline-secondary btn-sm"
              :title="translate('draft.addFileHelperText')">
                <icon-plus/>
                {{translate('draft.addFile')}}
              </label>
              <!-- <button v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" class="btn btn-primary" type="button">Yüklemeyi Başlat</button> -->

            </div>                       
          </div>   
          <div class="row">            
            <div class="col">
              <div class="alert alert-info d-flex align-items-center" v-if="totalFileSizeLimit">
                <icon-info-circle-fill width="24" height="24" viewBox="0 0 16 16" class="flex-shrink-0 mr-2"/>                
                <div v-html="translate('draft.fileSizeLimit:' +  totfileSizeLimit(totalFileSizeLimit))">
                </div>
              </div>
            </div>
          </div>       
          <div class="clear-fix"></div>
          <div>
            <div
              v-for="file in files"
              :key="file.id"
              v-show="file.active || !file.Success"
              style="padding: 10px 0"
            >
              <div>
                {{ file.name }}
                <small class="text-muted">{{ file.size | prettyBytes }}</small>
              </div>
              <div class="progress" v-if="file.active">
                <div
                  class="progress-bar progress-bar-striped progress-bar-animated text-left"
                  role="progressbar"
                  aria-valuenow="75"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :style="{ width: file.progress + '%' }"
                >
                  &nbsp;%{{ parseInt(file.progress, 10) }}
                </div>
              </div>
              <div class="text-danger" style="font-size:0.8rem" v-if="file.error">
                  <div v-for="ms in file.response.ModelState" :key="ms">
                      <div v-for="err in ms" :key="err">{{err}}</div>
                  </div>
              </div>
            </div>
            <div class="text-right">
              <label
                v-show="$refs.upload && $refs.upload.active"
                @click.prevent="$refs.upload.active = false"
                class="btn btn-primary btn-sm"
                type="button"
              >
              {{translate('draft.stopUpload')}}
              </label>
            </div>
          </div>
          <draftAlerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />
        </div>        
      <!-- </div> -->
      </tab-content>

      <tab-content tabName="ekler" :currentTab="tab" class="justify-content-md-center">
      <!-- <div class="row tab-panel justify-content-md-center" v-show="tab == 'ekler'"> -->
        <div class="col col-limit-1200">
          <div class="form-group">
            <label>{{translate('draftEyp.description')}}</label>
            <!-- <textarea
              v-model="data.Description"
              class="form-control"
              maxlength="2000"
            ></textarea> -->
            
            <text-area-input v-model="data.Description"  name="Description" className="form-control" :maxlength="2000" />

            <small class="text-muted">
              {{translate('draft.descriptionText')}}
            </small>
          </div>
          
          <div class="alert alert-info">
            <span v-html="translate('draft.selectAttachmentFile')"></span>
            <span v-if="sendAttachmentsToTargetSystems == 'Always'">{{translate('draft.butWillSendToTargets')}}</span>
            <span v-else-if="sendAttachmentsToTargetSystems == 'Never'" v-html="translate('draft.andWillSendToTargets')"></span>
          </div>

          <label>{{translate('draftEyp.attachments')}}</label>
          <div class="form-control" style="padding: 0; margin-bottom:1rem; height:auto;">
            <table v-if="data.Attachments && data.Attachments.length" class="table table-striped table-hover table-borderless">
              <thead>
                <tr>
                  <th></th>
                  <th>{{translate('draft.fileName')}}</th>
                  <th class="text-right" style="width: 120px">{{translate('draft.size')}}</th>
                  <th class="text-center" style="width: 120px;" v-if="isAttachmentSendingStateVisible" v-html="translate('draft.sendToTargets')"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in data.Attachments" :key="i.Id">
                  <td
                    class="remove align-top"
                    :title="translate('remove')"
                    @click="removeAttachment(i)"
                  ></td>
                  <td class="content">
                    <!-- <a
                      v-if="canDownload"
                      :title="translate('download')"
                      href="#void"
                      @click.prevent="downloadAttachment(i)"
                      >{{ i.FileName }}</a
                    >
                    <span v-else>{{i.FileName}}</span> -->
                    <file-download-link  :isOnlineView="onlineViewEnabled" :document="i" @download="downloadAttachment" @preview="showFilePreview" ></file-download-link>
                  </td>
                  <td class="text-right">{{ i.Size | prettyBytes }}</td>
                  <td class="text-center" v-if="isAttachmentSendingStateVisible">
                    <input type="checkbox" v-model="i.SendToTargetSystems" />
                  </td>
                </tr>
              </tbody>
            </table>
            <label for="attachmentUpload" v-else class="text-muted text-center" style="padding:40px; display:block; cursor:pointer;">
              {{translate('warnings.noAttachmentUploaded')}}
            </label>
          </div>


          <file-upload
            style="display:none;"
            ref="uploadAttachments"
            name="Attachments"
            input-id="attachmentUpload"
            v-model="attachments"
            :post-action="
              axios.defaults.baseURL +
              '/draft/addfile/' +
              data.Id +
              '?isAttachment=true'
            "
            :multiple="true"
            :drop="false"
            :thread="1"
            @input="$refs.uploadAttachments.active = true"
            chunk-enabled
            :chunk="{
              headers: {
                token: axios.defaults.headers.common['token'],
              },
              action:
                axios.defaults.baseURL +
                '/draftattachment/addfilechunk/' +
                data.Id +
                '?isAttachment=true',
              //minSize: 1048576,
              minSize: 0,
              maxActive: 3,
              maxRetries: 3,

              // Example in the case your backend also needs the user id to operate
              startBody: {
                //user_id: user.id
              },
            }"
          >
            <!-- <div class="row select-file" id="attachments">
              <div class="col">
                İşe dahil edilecek ek dosyaları seçmek için buraya tıklayınız...
              </div>
            </div> -->
          </file-upload>
          <div class="text-right">
            <!-- <button v-show="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true" class="btn btn-primary" type="button">Yüklemeyi Başlat</button> -->
            <label
              v-show="$refs.uploadAttachments && $refs.uploadAttachments.active"
              @click.prevent="$refs.uploadAttachments.active = false"
              class="btn btn-sm btn-danger"
              type="button"
              style="margin-right:12px;"
            >
              <icon-stop/>
              {{translate('draft.stopUpload')}}
            </label>
            <label for="attachmentUpload" class="btn btn-outline-secondary btn-sm"><icon-plus/> {{translate('draft.addAttachment')}}</label>
          </div>

          <ul>
            <!-- <li>{{file.name}} {{file.active}} {{file.success}} {{file.progress}} {{file.error}}</li> -->
            <li
              v-for="file in attachments"
              :key="file.id"
              v-show="!file.success"
            >
              <div>{{ file.name }}</div>
              <div class="progress" v-if="file.active">
                <div
                  class="progress-bar progress-bar-striped progress-bar-animated text-left"
                  role="progressbar"
                  aria-valuenow="75"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :style="{ width: file.progress + '%' }"
                >
                  &nbsp;%{{ parseInt(file.progress, 10) }}
                </div>
              </div>
                  <div class="text-danger" style="font-size:0.8rem" v-if="file.error">
                      <div v-for="ms in file.response.ModelState" :key="ms">
                          <div v-for="err in ms" :key="err">{{err}}</div>
                      </div>
                  </div>
            </li>
          </ul>
          <draftAlerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />
        </div>
      <!-- </div> -->
      </tab-content>
      <tab-content tabName="ozet" :currentTab="tab">      
      <!-- <div class="row tab-panel" :data-tabname="ozet" v-if="tab == 'ozet'"> -->
        <div class="col">
          <draft-preview
            ref="preview"
            :data="data"
            :user-list="userList"
            :target-system-list="targetSystems"
            :category-list="categories"
          ></draft-preview>
        </div>
        <draftAlerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />    
      <!-- </div> -->        
      </tab-content>

      <template v-slot:footer>
          <div class="row">
            <div class="col">
              <tab-nav v-model="tab" :nextButton="false" :tabs="tabs"></tab-nav>                  
              <button
                accesskey="k"
                type="submit"
                class="btn btn-info ml-2"
                v-html="translate('draft.saveToDrafts')"
              >
              </button> 
            </div>
            <div class="col text-right">
              <button
                type="button"
                @click="startCirculation()"
                v-show="tab == 'ozet'"
                class="btn btn-success"
                style="margin-right: 12px"
              >
              {{translate('draft.circulate')}}
              </button>                       
              <tab-nav v-model="tab" :prevButton="false" :tabs="tabs" ></tab-nav>
            </div>
          </div>
      </template>
    </form-container>
    <draft-eyp
      v-if="showEypEditor"
      :draft="data"
      @close="closeEypEditor"
    ></draft-eyp>
    <custom-target-system
      v-if="customTargetSystem"
      :model="customTargetSystem"
      @onsave="setCustomTargetSystem"
      @close="customTargetSystem = null"
    ></custom-target-system>
    <file-preview v-if="fileDetail" :file="fileDetail" :isOnlineView="onlineViewEnabled" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
    <Transition>
        <MergePdf v-if="mergePdf && data.Id" @closeMerge="mergePdf = false" @success="mergeSuccess" :Id="data.Id"/>
    </Transition>
  </div>
 
</template>

<script>
//import DraftService from '../services/draft.js';
import formMixin from "../formMixin.js";
import formContainer from "../components/FormContainer.vue";
import CustomTargetSystem from "@/components/CustomTargetSystem";
import draftEyp from "../components/DraftEyp.vue";
import stepEditor from "../components/StepEditor.vue";
import draftPreview from "./DraftPreview.vue";
import selectMultiple from "../components/SelectMultiple.vue";
import fileUpload from "vue-upload-component"; // https://lian-yue.github.io/vue-upload-component/#/en/documents#getting-started-npm
import signatureLocation from "../components/DraftSignatureLocation.vue";
import ObjectId from "../ObjectId.js";
import axios from "axios";
import dateInput from "../components/DateInput.vue";
import selectInput from "../components/SelectInput.vue";
import tab from '../components/Tab.vue';
import tabNav from '../components/TabNav.vue';
import tabContent from '../components/TabContent.vue';
import draftAlerts from '../components/DraftAlerts.vue';
import TextAreaInput from '@/components/TextAreaInput.vue';
import fileDownloadLink from '../components/FileDownloadLink.vue'
import filePreview from '../components/FilePreview.vue';

import MergePdf from '../components/MergePDF.vue'

import iconPlus from '../components/Icons/plus.svg';
import iconStop from '../components/Icons/stop-fill.svg';
import iconInfoCircleFill from '../components/Icons/info-circle-fill.svg';

export default {
  mixins: [formMixin],
  components: {
    stepEditor,
    formContainer,
    selectMultiple,
    fileUpload,
    draftPreview,
    signatureLocation,
    draftEyp,
    CustomTargetSystem,
    dateInput,
    selectInput,
    tab,
    tabNav,
    tabContent,
    draftAlerts,
    iconPlus,
    iconStop,
    iconInfoCircleFill,
    TextAreaInput,
    fileDownloadLink,
    filePreview,
    MergePdf
  },
  created() {
    this.getDepartments({predicate: "IsActive= true" })
    .then(x => {
        this.departments = x.Result;
        this.data.DepartmentId = this.availableDepartments[0]?.Id;

    }).catch(x => {
        console.log("Departman listesi yüklenemedi:", x);
    });

    this.getOnlineViewPermission()
    .then(x => {
        this.onlineViewEnabled = x;
    }).catch(x => {
        console.warn("getOnlineViewPermission alınamadı:", x);
        this.onlineViewEnabled = true;
    });
    this.getCategories({predicate: "IsActive=true"})
    .then(x=> {
      this.categories = x.Result;
    })
    .catch(x => {
      console.log("Kategori listesi yüklenemedi: ", x);
    });

    this.getCirculationProfileSchemasDetailed({
      OrderBy: "Name",
      Predicate: "IsActive=true",
    })
      .then((x) => {
        if(this.hasAuth('DraftCirculationCustomization')) {
          this.circulationProfileSchemas = [
            { Id: null, Name: this.translate('draft.jobSpecificFlow')},
          ].concat(x.Result);
        } else {
          this.circulationProfileSchemas = x.Result;
        }
      })
      .catch((x) => {
        console.log("Tanımlı akışlar listesi yüklenemedi:", x);
      });

    this.getTargetSystems({ OrderBy: "Name" })
      .then((x) => {
        this.targetSystems = x.Result;
        this.getData(this.$route.params.id).then(() => {
          if(this.$route.params.id == "000000000000000000000000") {
            //this.data.TargetDate = new Date().toISOString().substring(0, 10);
            this.data.TargetDate = null;
            this.data.CirculationProfileSchemaId = '';
          }

          this.data.DepartmentId = this.availableDepartments[0]?.Id;
          this.backupSteps = Object.assign([], this.data.Steps);
          this.backupTargetSystemIds = Object.assign([], this.data.TargetSystemIds);
          if(this.$route.query.incomingDocId){
            this.data.IncomingDocId = this.$route.query.incomingDocId;
          }
          this.checkTargetSystem();
          console.log("Backup steps set edildi.");
          this.isTargetDatePast()
      });
      })
      .catch((x) => {
        console.log("Aclıcı listesi yüklenemedi:", x);
      });

    this.getUsers({ predicate: "IsActive= true" })
      .then((x) => {
        this.userList = x.Result.sort((a, b) => {
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else {
            return 0;
          }
        });

        console.log(this.userList);
      })
      .catch((x) => {
        console.log("Kullanıcı listesi yüklenemedi:", x);
      });
  },
  beforeRouteLeave (to, from , next) {
    if(!this.startCirculationButtonClicked && ((this.data.Title != null) || this.data.Steps.length != 0 || this.data.Documents.length != 0)){
      this.$swal({
        title: this.translate('warnings.changesWillBeLost'),
        text: this.translate('warnings.changesWillBeLostText'),
        icon: 'warning',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor: 'green',
        denyButtonColor:  '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translate('leavePage'),
        cancelButtonText:  this.translate('cancel'),
        denyButtonText: this.translate('saveToDrafts'),
        customClass: {
          container: 'swalContainer',
          popup: 'swal-popup',
          htmlContainer: 'htmlContainer',
          actions: 'swalActions',
          denyButton: 'denyButton',
        }
      }).then((result) => {
        if (result.isConfirmed) {
          next()
        }
        if (result.isDenied) {
          this.saveDraft()
        }
        if (result.isDismissed) {
          next(false)
        }
      })
    }else{
      next()
    }
  },
  mounted(){    
    this.enableFormValidation();
  },
  data() {
    return {
      loading: false,
      modelName: "Draft",
      data: {
        TargetDate: null,
        DepartmentId: null,
        Owner: { Id: this.$root.$data.login.User.Id }
      },
      validationData: [],
      circulationProfileSchemas: [],
      targetSystems: [],
      categories: [],
      userList: [],
      files: [],
      departments: [],
      attachments: [],
      backupSteps: null,
      backupTargetSystemIds: null,
      tab: "genel",
      preview: false,
      showEypEditor: false,
      customTargetSystem: null,
      redirectToList: false,
      startCirculationButtonClicked: false,
      targetSystemsSignatureStandard: null,
      canCreateEYP: true,
      onlineViewEnabled: true,
      fileDetail: null,           // Önizlemesi görüntülenecek dosya
      mergePdf:  false,
      tabs: [
        { key: "genel", text: this.translate('tabs.draftTabs.general') },
        { key: "dolasim", text: this.translate('tabs.draftTabs.flow') },
        { key: "dosya", text: this.translate('tabs.draftTabs.docs') },
        { key: "ekler", text: this.translate('tabs.draftTabs.attachments') },
        { key: "ozet", text: this.translate('tabs.draftTabs.summary') },
      ],
      removedDocuments: [],
    };
  },
  watch: {
    'data.TargetSystemIds' : function(){
      this.checkTargetSystem();
    },
    'data.DepartmentId': function(newDept) {
      console.log('Departman değişti: ', newDept);
      console.log('Privacy: ', this.data.Privacy);
      if(!newDept) {
        if(this.data.Privacy == 'Secret') {
          this.data.Privacy = 'TopSecret';
        }
      }
    },
    files: function (oldFiles, newFiles) {
      newFiles
        .filter((x) => x && x.response.attachment)
        .forEach((element) => {
          if (
            this.data.Documents.filter(
              (d) => d.Id == element.response.attachment.Id
            ).length == 0
          ) {
            this.data.Documents.push(element.response.attachment);
            this.data.Documents.forEach(doc => {
              this.changeDocumentsSignatureFormat(doc)
            });
            console.log("Documents", this.data.Documents);
            //element.documentOK = true;
          }

          this.$refs.upload.remove(element);
        });
    },
    attachments: function (oldFiles, newFiles) {
      newFiles
        .filter((x) => x && x.response.attachment)
        .forEach((element) => {
          if (
            this.data.Attachments.filter(
              (d) => d.Id == element.response.attachment.Id
            ).length == 0
          ) {
            this.data.Attachments.push(element.response.attachment);
            console.log("Attachments", this.data.Attachments);
          }

          this.$refs.uploadAttachments.remove(element);
        });
    },
  },
  computed: {
    
    relatedJobDate(date,locale){
      if(!date)
        return null;
        
      if(!locale)
      {
          var login = window.localStorage.getItem('user');
          if(login)
          {
              login = JSON.parse(login);
              locale = login.Account?.Params?.DefaultDateLocale
          }
          
          if(!locale)
              locale = window.settings.defaultLocale ?? "tr";

      }

      if(typeof date == 'string' && !isNaN(date))
          date = new Date(parseInt(date, 10));

      if(!(date instanceof Date))
          date = new Date(date);

      return date.toLocaleDateString([locale]) + ' ' + date.toLocaleTimeString([locale]);
    },
    // İş taslağına özel dolaşım profili mi?
    isSpecialProfile() {
      if(!this.hasAuth('DraftCirculationCustomization'))
        return false;

      return this.data.CirculationProfileSchemaId == null;
    },
    isBankOrder(){  // Seçilen kategoriler doğrultusunda bu iş bir banka talimatı mı?
      return this.data.
        CategoryIds?.map(cId => this.categories.filter(c => c.Id == cId)[0]?.Type)
        .filter(t => t == 'BankOrder').length > 0;
    },
    isContract(){  // Seçilen kategoriler doğrultusunda bu iş bir sözleşme mi?
      return this.data.
        CategoryIds?.map(cId => this.categories.filter(c => c.Id == cId)[0]?.Type)
        .filter(t => t == 'Contract').length > 0;
    },
    totalDocumentSize() {
      return this.data.Documents?.map((x) => x.File.Size).reduce(
        (accumulator, currentValue) => accumulator + currentValue
      , 0);
    },
    totalFileSizeLimit(){
      return this.selectedTargetSystems?.filter(x => x && x.TotalFileSizeLimit > 0).min(x => x.TotalFileSizeLimit)
    },
    circulationProfileSchema() {
      return this.circulationProfileSchemas.filter(
        (x) => x.Id == this.data.CirculationProfileSchemaId
      )[0];
    },
    availableCirculationProfileSchemas(){
      if (this.data.DepartmentId)
        return this.circulationProfileSchemas.filter((x) => !x.Department || x.Department.Id == this.data.DepartmentId)
        else
        return this.circulationProfileSchemas;
    },
    
    
    availableCategories(){
      var types = this.data.
        CategoryIds?.map(cId => this.categories.filter(c => c.Id == cId)[0]?.Type)
        .filter(t => t != 'General');

      if(types && types.length > 0) {
        types.push('General');
        return this.categories.filter(x => types.indexOf(x.Type) >= 0);
      } else {
        return this.categories;
      }
    },
    listAllUsers(){
      return this.$store.state.approvalUserEditor.ListAllusers;
    },    
    availableUserList() {
      if (!this.userList) return [];

      if(this.listAllUsers)
        return this.userList;

      if (this.CirculationProfileSchemaId || this.hasAuth("Admin"))
        return this.userList;

      var userDepartmentIds = this.$root.$data.login.User.DepartmentIds;
      if (!userDepartmentIds || userDepartmentIds.length == 0)
        return this.userList;

      var result = this.userList.filter(
        (x) =>
          x.Departments == null ||
          x.Departments.length == 0 ||
          x.Departments.some((d) =>
            userDepartmentIds.some((udId) => udId == d.Id)
          )
      );

      return result;
    },
    availableTargetSystems() {
      if (this.CirculationProfileSchemaId || this.hasAuth("Admin"))
        return this.targetSystems;

      var userDepartmentIds = this.$root.$data.login.User.DepartmentIds;
      if (!userDepartmentIds || userDepartmentIds.length == 0)
        return this.targetSystems;

      var result = this.targetSystems.filter(
        (t) =>
          !t.Department ||
          userDepartmentIds.some((udId) => udId == t.Department.Id)
      );
      return result;
    },
    departmentBasedAvailableTargetSystems(){
      if (this.data.DepartmentId)
        return this.availableTargetSystems.filter((x) => !x.Department || x.Department.Id == this.data.DepartmentId)
        else
        return this.availableTargetSystems;
    },
    selectedTargetSystems(){
      
        if(!this.data.TargetSystemIds || !this.targetSystems)
            return [];
        return this.data.TargetSystemIds.map(x => this.targetSystems.filter(t => t.Id == x)[0]).filter(x => x) || [];
    },
    selectedDepartment(){
      return this.departments?.filter(x => x.Id == this.data.DepartmentId)[0];
    },
    availableDepartments(){
        var result = (this.departments ?? []).filter(x => x.IsActive);
        if(this.hasAuth('Admin') || (this.$root.$data.login.User.DepartmentIds ?? []).length == 0)
          result =  [{Id:'', Name:  this.translate('draft.departmentIndependent')}].concat(result);
        
        return result;
    },
    sendAttachmentsToTargetSystems(){
      return this.$root.$data.login.Account.Params.SendAttachmentsToTargetSystems;
    },
    isAttachmentSendingStateVisible(){
      return this.$root.$data.login.Account.Params.SendAttachmentsToTargetSystems != 'Always' && this.$root.$data.login.Account.Params.SendAttachmentsToTargetSystems != 'Never';
    },
    canDownload(){
      return this.$root.$data.login.User.Id == this.data.Owner?.Id;
    },
    isFileSizeLimitsExceed(){
      return this.totalFileSizeLimit <= this.totalDocumentSize;
    },
    
  },
  methods: {
    mergeSuccess(){
      this.refreshDocuments();
      this.mergePdf = false;
    },
    totfileSizeLimit(num){
      // jacked from: https://github.com/sindresorhus/pretty-bytes
      if (typeof num !== 'number' || isNaN(num)) {
          return num;
      }

      var exponent;
      var unit;
      var neg = num < 0;
      var units = ['B', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

      if (neg) {
          num = -num;
      }

      if (num < 1) {
          return (neg ? '-' : '') + num + ' B';
      }

      exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
      num = (num / Math.pow(1024, exponent)).toFixed(2) * 1;
      unit = units[exponent];

      return (neg ? '-' : '') + num + ' ' + unit;
    },
    showFilePreview(document, type, isFormatted) {
      if(this.tab == "dosya"){
        document.IsAttachment = false
      }else{
        document.IsAttachment = true
      }
      document.EntityType = "Draft"
      this.fileDetail = document;
      this.viewerType = type;
      this.fileDetail.EntityId = this.data.Id;
      if(isFormatted)
          this.fileDetail.IsFormatted = true;
    },
    isTargetDatePast(){ //Benzer iş oluşturulduğunda, Hedeflenen bitiş tarihi şu anki tarihten önceki bir tarihse, onu şuanki tarihe set eder. 
      const today = new Date()
      const targetDate = new Date(this.data.TargetDate);
      if (this.data.TargetDate != null && targetDate < today) {
        this.data.TargetDate = today.toISOString().split("T")[0]; // Format the date to "YYYY-MM-DD" format
      }
    },
    checkTargetSystem(){
      
      const targetSystems = this.selectedTargetSystems
      
      if(targetSystems.length > 0){
        
        var t = targetSystems.filter( x => x.SignatureStandard != null)
        if(t.length > 0){
          this.targetSystemsSignatureStandard = t[0].SignatureStandard
        }
        else{
          this.targetSystemsSignatureStandard = null
        }
        if(this.data.Documents.length > 0){
          this.data.Documents.forEach(doc => {
            this.changeDocumentsSignatureFormat(doc)
          });
        }
      }else{
        
        this.targetSystemsSignatureStandard = null
      }
      this.CanTargetSystemCreateEYP()
    },
    canSelectSignatureStandard(){
      if(this.targetSystemsSignatureStandard == "" || this.targetSystemsSignatureStandard == null)
        return true
      else
        return false
    },
    changeDocumentsSignatureFormat(document){
      var docExtension = document.File.FileName.split('.').pop().toLowerCase();
      if(this.targetSystemsSignatureStandard != null){
        if(this.targetSystemsSignatureStandard == 'PAdES'){
          if(docExtension == "pdf")
            document.SignatureFormat = this.targetSystemsSignatureStandard
          else
            document.SignatureFormat = 'CAdES'
        }
        else if(this.targetSystemsSignatureStandard == 'CAdES' || this.targetSystemsSignatureStandard == 'CAdES_Serial'){
          document.SignatureFormat = this.targetSystemsSignatureStandard
        }
        else if(this.targetSystemsSignatureStandard == 'Guarantee'){
          if(docExtension != "xml")
            document.SignatureFormat = 'CAdES'
          else
            document.SignatureFormat = this.targetSystemsSignatureStandard
        }
        else if(this.targetSystemsSignatureStandard == 'EYP' || this.targetSystemsSignatureStandard == 'EYP2'){
          if(docExtension != "eyp")
            document.SignatureFormat = 'CAdES'
        }else{
          document.SignatureFormat = this.targetSystemsSignatureStandard
        }
      }else{
        this.targetSystemsSignatureStandard = null
      }
    },
    CanTargetSystemCreateEYP(){
      if(this.targetSystemsSignatureStandard == null || this.targetSystemsSignatureStandard == 'EYP' || this.targetSystemsSignatureStandard == 'EYP2')
        this.canCreateEYP = true
      else
        this.canCreateEYP = false;
    },
    checkInput(value, event) {
      // Check for invalid characters
      if (/[<>]/.test(event.target.value)) {
        alert(this.translate('errors.invalidSymbols'))
        const editedText = ""
        this.$set(this.data, value, editedText)
      } else {
        this.$set(this.data, value, event.target.value)
      }
    },
    isEYP(value){
      return value == 'EYP' || value == 'EYP2';
    },
    departmentSelectChanged(value){
      this.data.DepartmentId = value?.Id;
      
      if(this.data.DepartmentId){
     
        if(this.circulationProfileSchema && this.circulationProfileSchema.Department && this.circulationProfileSchema.Department.Id != this.data.DepartmentId){

          this.data.CirculationProfileSchemaId = null;
          this.data.TargetSystemIds = [];
          this.data.Steps = [];
        }else{
   
          var tsList = this.departmentBasedAvailableTargetSystems;
          this.data.TargetSystemIds = this.data.TargetSystemIds.filter(r=> tsList.map(x => x.Id).includes(r));

        }
      }
      this.$forceUpdate();
    },
    changeDocumentType($event) {
      if ($event.target.value == "BankOrder") {
        this.data.TargetDate = new Date().toISOString().substring(0, 10);
        this.$forceUpdate();
      } else {
        this.data.TargetDate = null;
      }
    },
    customizeTargetSystem(targetSystem) {
      axios.get("targetsystem/customize/" + targetSystem.Id)
      .then(x => {
        console.log('Genel Alıcı: ', x.data);
        this.customTargetSystem = x.data;
        this.customTargetSystem.IsSingleUse = true;
      })
      .catch(x => {
        console.warn('Alıcı çekilemedi: ', x);
        window.processErrorResponse(x, this);
      })

      //this.$refs.targetSystemSelect.$forceUpdate();
    },
    addEypButtonClick() {
      if (!this.hasModule("EYP")) {
        alert(this.translate('warnings.eypModuleNotActive'));
      } else {
        this.showEypEditor = true;
      }
    },
    resetComponent() {
      if (
        confirm(this.translate('warnings.draftWarning'))
      ) {
        this.$router.push({
          name: "DraftDetail",
          params: { id: window.emptyObjectId },
        });
        this.getData(window.emptyObjectId);
        this.files = [];
        this.tab = "genel";
      }
    },
    addNewCustomTargetSystem() {
      this.customTargetSystem = { Id: ObjectId.NewId(), IsSingleUse: true };
    },
    setCustomTargetSystem(targetSystem) {
      if (
        this.data.AdditionalTargetSystems == null ||
        this.data.AdditionalTargetSystems == undefined
      ) {
        this.data.AdditionalTargetSystems = [];
      }

      var ts = this.data.AdditionalTargetSystems.filter(
        (x) => x.Id == targetSystem.Id
      )[0];

      var index = ts ? this.data.AdditionalTargetSystems.indexOf(ts) : -1;

      if (index >= 0) {
        this.data.AdditionalTargetSystems[index] = targetSystem;
      } else {
        this.data.TargetSystemIds = this.data.TargetSystemIds.filter(x => x != targetSystem.Id);
        targetSystem.Id = ObjectId.NewId();
        this.data.AdditionalTargetSystems.push(targetSystem);
      }

      this.customTargetSystem = null;
      this.$refs.targetSystemSelect.$forceUpdate();
      this.$refs.preview.$forceUpdate();
    },
    removeCustomTargetSystem(item) {
      this.data.AdditionalTargetSystems = this.data.AdditionalTargetSystems.filter(x => x != item);
    },
    saveDraft() {
      if (!this.data.Title) {
        this.tab = "genel";
        this.$forceUpdate();
        alert(this.translate('warnings.enterJobNameBeforeSave'));
        setTimeout(() => {
          this.$refs.draftTitle.focus();
        }, 50);
        return;
      }

      this.save().then((x) => {
        console.log("Save result: ", x);
        if (x && x.status == 200 && x.data) {
          this.data = x.data;
          this.$router.replace({ params: { id:this.data.Id } });
          this.$alert(this.translate('messages.draftSaveSuccess'), this.translate('messages.success2'), "success");
          this.$router.push({ name: "DraftDetail", params:{ id: this.data.DraftId } });
        }
      });
    },
    validateDraft() {
      this.validate().then((x) => {
        console.log("Validate result: ", x);
        if (x && x.status != 200) {
          this.validationData = x.data;
        }
      });
    },
    showPreview() {
      this.save().then((x) => {
        if (x.data.Success) {
          this.preview = true;
        }
      });
    },
    getFileExtension(fileName) {
      if (!fileName) return null;

      return fileName.split(".").reverse()[0].toLowerCase();
    },
    circulationProfileSchemaChanged(value) {
      this.data.CirculationProfileSchemaId = value?.Id;
      if (this.data.CirculationProfileSchemaId || this.data.CirculationProfileSchemaId == '') {
        var cps = this.circulationProfileSchema;
        if (cps) {
          this.data.Steps = Object.assign([], cps.Steps);
          this.data.TargetSystemIds = Object.assign(
            [],
            cps.TargetSystems?.filter(x => x.IsActive == true).map((x) => x.Id)
          );
          if(!this.data.TargetSystemIds || this.data.TargetSystemIds.length == 0){
            if(this.hasAuth('DraftCirculationCustomization'))
              this.data.CirculationProfileSchemaId = null;
          }
        } else {
          this.data.CirculationProfileSchemaId = null;
        }
      } else {
        this.data.CirculationProfileSchemaId = null;
        this.data.TargetSystemIds = this.backupTargetSystemIds;
        this.data.Steps = this.backupSteps;
      }
    },
    customizeCirculationProfile() {
      this.data.CirculationProfileSchemaId = null;
    },
    removeDocument(document) {
      this.removedDocuments.push(document);
      this.data.Documents = this.data.Documents.filter((x) => x != document);
    },
    removeAttachment(attachment) {
      this.data.Attachments = this.data.Attachments.filter(
        (x) => x != attachment
      );
    },
    downloadDocument(document) {
      // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
      return axios
        .post(`/draft/createDocumentUrl/`, {
          EntityId: this.data.Id,
          DocumentId: document.Id,
        })
        .then((x) => {
          console.log("createDocumentUrl Result:", x.data);
          window.open(x.data.Data.Url);
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    downloadAttachment(attachment) {
      // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
      return axios
        .post(`/draft/createAttachmentUrl/`, {
          EntityId: this.data.Id,
          AttachmentId: attachment.Id,
        })
        .then((x) => {
          console.log("createAttachmentUrl Result:", x.data);
          window.open(x.data.Data.Url);
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    showSignatureEditor(document, visibility) {
      console.log("signaturaeditor:", document);
      document.showLocator = visibility;
      this.$forceUpdate();
      this.validate();
    },
    closeEypEditor() {
      this.refreshDocuments();
      this.showEypEditor = false;
    },
    refreshDocuments() {
      this.loading = true;
      return axios
        .get(`/${this.modelName}/getDocuments/${this.data.Id}`)
        .then((x) => {
          this.loading = false;
          var docs = x.data;
          var currentDocs = this.data.Documents
          var removedDocs = this.removedDocuments;

          docs.forEach((x) => {
            var current = currentDocs.filter((d) => d.Id == x.Id)[0];
            if (current) {
              current.File = x.File;
            } else {
              if(removedDocs.filter((d) => d.Id == x.Id)[0] == undefined)
                currentDocs.push(x);
            }
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    startCirculation() {
      console.log(this.data);
      this.startCirculationButtonClicked = true;
      this.loading = true;
      return axios
        .post(`/draft/startCirculation`, this.data)
        .then((x) => {
          console.log("POST Result:", x.data);
          if (x.data.Success) {
            this.$router.push({
              name: "JobMyDetail",
              params: { id: x.data.Data.Id },
            });
          } else {
            alert(this.translate(x.data.ErrorMessages));
            this.loading = false;
          }
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    categorySelectChanged(){
      if(this.isBankOrder){
        this.data.TargetDate = new Date().toISOString().substring(0, 10);
        if(!this.data.Currency)
          this.data.Currency= "TRY";     
      }
      else if(this.isContract){
        this.data.TargetDate = new Date().toISOString().substring(0, 10);
        if(!this.data.ContractCurrency)
          this.data.ContractCurrency= "TRY";
      }
      else
        this.data.Amount = 0;
        this.data.Currency = "TRY";
        this.data.ContractAmount = null;
        this.data.ContractCurrency = "TRY";
    },
  }
};
</script>



<style scoped>
td.remove {
  color: red;
  width: 32px;
  background-image: url('data:image/svg+xml,<svg class="bi bi-x-circle" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/><path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/></svg>');
  background-repeat: no-repeat;
  background-size: 1rem 1rem;
  content: "";
  background-position: center center;
  cursor: pointer;
}

td.remove:hover {
  background-image: url('data:image/svg+xml,<svg class="bi bi-x-circle-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">   <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.146-3.146a.5.5 0 0 0-.708-.708L8 7.293 4.854 4.146a.5.5 0 1 0-.708.708L7.293 8l-3.147 3.146a.5.5 0 0 0 .708.708L8 8.707l3.146 3.147a.5.5 0 0 0 .708-.708L8.707 8l3.147-3.146z"/> </svg>');
}

.file-uploads {
  border: 2px dotted #ddd;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  width: 100%;
}

.file-uploads label {
  cursor: pointer;
}

.signature-format {
  border: 1px solid transparent;
  background-color: transparent;
}

.signature-format:focus, .signature-format:hover {
  border: 1px solid #ced4da;
  outline: none;
}

.signature-format:focus {
  background-color: #FFF;
}

.btn-disabled-custom:disabled{
  background-color: transparent;
  color:  #6c757d;
  border-color: #6c757d;
  z-index: 999;
}


.row.tab-panel {
  min-height: 610px;
}
</style>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.swal-popup{
  display: none;
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  width: 36em;
  max-width: 100%;
  padding: 1.25em;
  border: none;
  border-radius: .3125em;
  font-family: inherit;
  font-size: 1rem;
}
.swalContainer{
  display: flex;
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: .625em;
  overflow-x: hidden;
  transition: background-color .1s;
  background-color: #00000098 !important;
  -webkit-overflow-scrolling: touch;
}
.denyButton{
    border: 0;
    border-radius: .25em;
    background: initial;
    background-color: #3085d6;
    color: #fff;
    font-size: 1.0625em;
}
.swalActions{
  display: flex;
  flex-direction: row-reverse;
}
.htmlContainer{
  text-align: center;
}
.informationIcon{
    width: 24px;
    height: auto;
}
</style>